import {
  DemoAlarmIngestPayload,
  DemoAlarmIngestResponse,
} from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';
import { buildIngestBody } from './buildIngestBody';
import { parseIngestResponse } from './parseIngestResponse';

export function useIngestDemoAlarms(
  onSuccess?: (
    data: DemoAlarmIngestResponse,
    variables: DemoAlarmIngestPayload
  ) => void,
  onError?: (error: Error, variables: DemoAlarmIngestPayload) => void,
  onSettled?: () => void
) {
  const request = new Request('/v2/orm/demo_portal/ingest?process=true', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  });

  return useAuthenticatedMutation<
    DemoAlarmIngestResponse,
    DemoAlarmIngestPayload
  >(request, {
    getBody: buildIngestBody,
    responseModifier: parseIngestResponse,
    onSuccess,
    onError,
    onSettled,
  });
}

export default useIngestDemoAlarms;
